import * as types from '../../actions/actionsTypes/individuoActionType';

export const initialStateDocenti = {
    docenti: [],
    error: []
};

export const docentiReducer = (state = initialStateDocenti, action) => {

    switch (action.type){

        case types.GET_DOCENTI_BY_OBJECTID_SUCCESS:
            return {
                ...state,
                docenti: action.docenti.map(d => ({...d, idAnagrafica: d.id}))
            };

        case types.GET_DOCENTI_BY_OBJECTID_FAIL:
            return{
                ...state,
                error: [action.error, ...state.error]
            };

        case types.INIT_DOCENTI:
            return{
                docenti: [],
                error: []
            };

        default:
            return state
    }
};

